import { render, staticRenderFns } from "./ChangeOfInceptionDate.vue?vue&type=template&id=e1c68894&scoped=true&"
import script from "./ChangeOfInceptionDate.vue?vue&type=script&lang=js&"
export * from "./ChangeOfInceptionDate.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOfInceptionDate.vue?vue&type=style&index=0&id=e1c68894&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c68894",
  null
  
)

export default component.exports